/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */

import { FormPasswordValidation } from '../../lib/interfaces/Form';

export const ERRORS = {
	REQUIRED: 'requiredField',
	INVALID: 'isInvalid',
	MIN_LENGTH: 'minLengthValidationError',
	MAX_LENGTH: 'maxLengthValidationError',
	HAS_UPPERCASE: 'hasUpperCaseLetterValidationError',
	HAS_LOWERCASE: 'hasLowerCaseLetterValidationError',
	HAS_SPECIAL_CHAR: 'hasSpecialCharValidationError',
	HAS_NUMBER: 'hasNumberValidationError',
	ONLY_LATIN: 'hasLatinValidationError',
	PASSWORD_INVALID: 'passwordValidationGeneral',
	PASSWORD_DOESNT_MATCH: 'passwordDoesntMatch',
};

export const FILE_TYPES = {
	JPG: {
		label: '.jpg',
		value: 'image/jpeg',
		key: 'jpg',
	},
	JPEG: {
		label: '.jpeg',
		value: 'image/jpeg',
		key: 'jpeg',
	},
	PNG: {
		label: '.png',
		value: 'image/png',
		key: 'png',
	},
	SVG: {
		label: '.svg',
		value: 'image/svg',
		key: 'svg',
	},
	PDF: {
		label: '.pdf',
		value: 'application/pdf',
		key: 'pdf',
	},
	DOC: {
		label: '.doc',
		value: 'application/msword',
		key: 'doc',
	},
	DOCX: {
		label: '.docx',
		value:
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		key: 'docx',
	},
};

export const vEmail = (emailValue: string) =>
	emailValue.match(/^[\w-\.()+-]+@([\w-]+\.)+[\w-]{2,4}$/g);

export const vMaxLength = (value: string, max: number) =>
	value?.split('').length <= max;

export const vMinLength = (value: string, min: number) =>
	value?.split('').length >= min;

export const vHasSpecialCharacters = (value: string) =>
	/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);

export const vHasSpecialCharactersForName = (value: string) =>
	/[`!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/.test(value);

export const vImageTypes = (file: File, types: string[] = []) => {
	const allowedExtension = types.length
		? types
		: [FILE_TYPES.JPEG.value, FILE_TYPES.JPG.value, FILE_TYPES.PNG.value];
	return allowedExtension.includes(file.type);
};

export const vLink = (linkValue: string) =>
	linkValue &&
	linkValue.match(
		/^(https?:\/\/)?([a-z\d.-]+)\.([a-z\.]{2,6})([\/\w .-]*)*(\?.*)?$/i,
	);

const hasUpperCase = (value: string) => /[A-Z]/.test(value);
const hasLowerCase = (value: string) => /[a-z]/.test(value);
const hasNumbers = (value: string) => /\d/.test(value);
const hasNonalphas = (value: string) => /\W/.test(value);
// eslint-disable-next-line
const hasNonLatin = (value: string) => /[^\u0000-\u007f]/.test(value);

export const vPassword = (
	value: string,
	validation: FormPasswordValidation | undefined,
) => {
	const response = [];
	if (validation?.hasLowerCase && !hasLowerCase(value)) {
		response.push(ERRORS.HAS_LOWERCASE);
	}
	if (validation?.hasUpperCase && !hasUpperCase(value)) {
		response.push(ERRORS.HAS_UPPERCASE);
	}
	if (validation?.hasNonalphas && !hasNonalphas(value)) {
		response.push(ERRORS.HAS_SPECIAL_CHAR);
	}
	if (validation?.hasNumbers && !hasNumbers(value)) {
		response.push(ERRORS.HAS_NUMBER);
	}
	if (
		validation?.allowNonLatin !== undefined &&
		!validation?.allowNonLatin &&
		hasNonLatin(value)
	) {
		response.push(ERRORS.ONLY_LATIN);
	}
	return response;
};

export const vShouldMatch = (value: any, matchValue: any) =>
	value === matchValue;
